type FilledTokens = { filledBg: string; filledColor: string };
type StandardTokens = { standardBg: string; standardColor: string };

/** Severity colors for Alert variant overrides via `palette.Alert`. */
export type ComponentAlertPalette = {
  info: FilledTokens & Partial<StandardTokens>;
  success: FilledTokens & Partial<StandardTokens>;
  warning: FilledTokens & Partial<StandardTokens>;
  error: FilledTokens & Partial<StandardTokens>;
};

const SEVERITIES = ["info", "success", "warning", "error"] as const;

/**
 * Maps project alert tokens to MUI v9 `palette.Alert` keys.
 * `setColor` in createThemeWithVars skips keys we provide, so these win over defaults.
 */
export function buildPaletteAlert(
  alert: ComponentAlertPalette
): Record<string, string> {
  const result: Record<string, string> = {};

  for (const severity of SEVERITIES) {
    const { filledBg, filledColor, standardBg, standardColor } = alert[severity];
    result[`${severity}FilledBg`] = filledBg;
    result[`${severity}FilledColor`] = filledColor;
    if (standardBg) result[`${severity}StandardBg`] = standardBg;
    if (standardColor) result[`${severity}StandardColor`] = standardColor;
  }

  return result;
}
